// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3-iQS","footer":"ModalError_footer__3xRrm"};